var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPremium28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#premium_28-a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m6.283 8.323.424.485c.914 1.045 1.371 1.567 1.851 1.674a1.5 1.5 0 0 0 1.204-.25c.399-.288.611-.948 1.036-2.27l.917-2.853c.693-2.156 1.04-3.233 1.56-3.52a1.5 1.5 0 0 1 1.45 0c.52.287.867 1.364 1.56 3.52l.917 2.853c.425 1.322.637 1.982 1.036 2.27a1.5 1.5 0 0 0 1.204.25c.48-.107.937-.63 1.851-1.674l.424-.485c2.105-2.405 3.157-3.608 3.803-3.632a1.5 1.5 0 0 1 1.357.75c.323.56-.137 2.091-1.055 5.153l-1.796 5.985c-.368 1.228-.552 1.841-.916 2.296a3 3 0 0 1-1.219.907c-.54.218-1.18.218-2.462.218H8.57c-1.281 0-1.922 0-2.462-.218a3 3 0 0 1-1.219-.907c-.364-.455-.548-1.068-.916-2.296l-1.796-5.986C1.26 7.534.8 6.002 1.123 5.442a1.5 1.5 0 0 1 1.357-.75c.646.024 1.698 1.227 3.803 3.632ZM6.5 23a1.5 1.5 0 0 0 0 3h15a1.5 1.5 0 1 0 0-3h-15Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "premium_28-a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremium28);
export default __webpack_public_path__ + "static/media/premium_28.37a5e233.svg";
export { ForwardRef as ReactComponent };